module.exports = __webpack_public_path__ + "static/media/slideMobile4.36b936f9.jpg";